(function(){
  var root=document.querySelector('.peak-hero-root'); if(!root) return;
  // gallery
  var main=root.querySelector('#peak-hero-gmain');
  root.querySelectorAll('.peak-hero-gthumb').forEach(function(t){
    t.addEventListener('click',function(){
      if(main){main.src=t.getAttribute('data-src');}
      root.querySelectorAll('.peak-hero-gthumb').forEach(function(x){x.classList.remove('is-active');});
      t.classList.add('is-active');
    });
  });
  // tier selection
  var vid=root.querySelector('#peak-hero-vid'), price=root.querySelector('#peak-hero-atc-price');
  root.querySelectorAll('.peak-hero-tier').forEach(function(tier){
    tier.addEventListener('click',function(){
      root.querySelectorAll('.peak-hero-tier').forEach(function(x){x.classList.remove('is-selected');});
      tier.classList.add('is-selected');
      var r=tier.querySelector('input'); if(r) r.checked=true;
      if(vid) vid.value=tier.getAttribute('data-vid');
      if(price) price.textContent=tier.getAttribute('data-price');
    });
  });
  // send straight to checkout (skip the cart page); subscription-only, always attach selling plan when present
  var form=root.querySelector('#peak-hero-form'), atc=root.querySelector('.peak-hero-atc');
  var planEl=root.querySelector('#peak-hero-plan');
  var planId=planEl?planEl.value:'';
  if(atc){
    atc.addEventListener('click',function(e){
      e.preventDefault();
      var id=vid?vid.value:null; if(!id){ return; }
      if(atc){ atc.disabled=true; atc.style.opacity='0.7'; atc.textContent='PROCESSING'; }
      var item={id:parseInt(id,10),quantity:1};
      if(planId){ item.selling_plan=parseInt(planId,10); }
      var items=[item];
      var protVid=(root.querySelector('#peak-hero-prot-vid')||{}).value;
      var protPlan=(root.querySelector('#peak-hero-prot-plan')||{}).value;
      if(protVid){
        var pi={id:parseInt(protVid,10),quantity:1};
        if(protPlan){ pi.selling_plan=parseInt(protPlan,10); }
        items.push(pi);
      }
      var fallback='/cart/'+id+':1';
      if(planId){ fallback='/cart/'+id+':1?selling_plan='+planId; }
      if(protVid){ fallback='/cart/'+id+':1'+(protVid?','+protVid+':1':''); }
      function add(attempt){
        return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
          .then(function(r){
            if(r.status===429 && attempt<2){ return new Promise(function(res){setTimeout(res,1200);}).then(function(){ return add(attempt+1); }); }
            if(!r.ok) throw new Error('add failed '+r.status);
            return r;
          });
      }
      fetch('/cart/clear.js',{method:'POST'})
        .then(function(){ return add(0); })
        .then(function(){ window.location.href='/checkout'; })
        .catch(function(){ window.location.href=fallback; });
    });
  }
  // countdown (persists per-visitor via localStorage, resets 12h)
  var clock=root.querySelector('#peak-hero-cd-clock');
  if(clock){
    var KEY='peak_hero_cd_end', now=Date.now(), end=parseInt(localStorage.getItem(KEY)||'0',10);
    if(!end||end<now){ end=now+12*3600*1000; localStorage.setItem(KEY,end); }
    function tick(){
      var s=Math.max(0,Math.floor((end-Date.now())/1000));
      var h=String(Math.floor(s/3600)).padStart(2,'0');
      var m=String(Math.floor((s%3600)/60)).padStart(2,'0');
      var ss=String(s%60).padStart(2,'0');
      clock.textContent=h+':'+m+':'+ss;
      if(s<=0){ end=Date.now()+12*3600*1000; localStorage.setItem(KEY,end); }
    }
    tick(); setInterval(tick,1000);
  }
})();
